import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';

@Injectable()
export class ConfigService {

    constructor() {}

    get authApiURI() {
        return environment.authUrl;
    }

    get resourceApiURI() {
        return environment.apiUrl;
    }

    get spaURI() {
        return environment.spaUrl;
    }
}
